import { convertToInty04h231mmjoh as convertToInt } from './internal/longAsBigInt/longAsBigInt.mjs';
import { _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne } from '../UShort.mjs';
import { _Char___init__impl__6a9atxkezg8puttbhz as _Char___init__impl__6a9atx } from '../Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toByte(a) {
  // Inline function 'kotlin.js.unsafeCast' call
  return a << 24 >> 24;
}
function numberToInt(a) {
  var tmp;
  if (!(a == null) ? typeof a === 'bigint' : false) {
    tmp = convertToInt(a);
  } else {
    tmp = doubleToInt(a);
  }
  return tmp;
}
function doubleToInt(a) {
  var tmp;
  if (a > 2147483647) {
    tmp = 2147483647;
  } else if (a < -2147483648) {
    tmp = -2147483648;
  } else {
    // Inline function 'kotlin.js.jsBitwiseOr' call
    tmp = a | 0;
  }
  return tmp;
}
function numberToDouble(a) {
  // Inline function 'kotlin.js.unsafeCast' call
  return Number(a);
}
function toShort(a) {
  // Inline function 'kotlin.js.unsafeCast' call
  return a << 16 >> 16;
}
function numberToChar(a) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = numberToInt(a);
  var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
  return _Char___init__impl__6a9atx(tmp$ret$0);
}
//region block: exports
export {
  numberToChar as numberToChar93r9buh19yek,
  numberToDouble as numberToDouble210hrknaofnhf,
  numberToInt as numberToInt1ygmcfwhs2fkq,
  toByte as toByte4i43936u611k,
  toShort as toShort36kaw0zjdq3ex,
};
//endregion

//# sourceMappingURL=numberConversion.mjs.map
